export default function({ $axios, redirect, store }) {
  $axios.onRequest((config) => {
    config.headers.common['x-auth-token'] = window.sessionStorage.getItem('_ar_fan_auth_token_');
  });
}
